// The work-shape tag — how this client wants to WORK: a one-off scoped
// project, an ongoing relationship, or a hybrid (a project that continues).
// Latched by the agents onto the project's metadata and settled at brief
// approval; see lib/work-shape.ts for the vocabulary.
//
// A TAG like SellerIntentTag beside it, not an alert: it says what the
// engagement IS, not that somebody must act. One component across the surfaces
// that show it (Explorer tables, the project page, Searches, Big clients) so a
// shape's label and tone can never drift between pages.
import { Badge, type BadgeTone } from "@recruiter/shared";

import { isWorkShape, workShapeLabel } from "../lib/work-shape";

const TONE_BY_SHAPE: Record<string, BadgeTone> = {
  // The settled default stays quiet; the two shapes that change how everything
  // downstream behaves (rates, cadence, hiring flow) get the louder tones.
  project: "neutral",
  ongoing: "info",
  hybrid: "accent",
};

/** Renders nothing while the project is unclassified (or the payload predates
 *  the field), so a caller can drop it in unconditionally. */
export function WorkShapeTag({ shape }: { shape: string | null | undefined }) {
  if (!isWorkShape(shape)) return null;
  return (
    <Badge tone={TONE_BY_SHAPE[shape] ?? "neutral"} size="sm">
      {workShapeLabel(shape)}
    </Badge>
  );
}
